import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homethree-blog',
  templateUrl: './homethree-blog.component.html',
  styleUrls: ['./homethree-blog.component.scss']
})
export class HomethreeBlogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
